module.exports = "/assets/images/ee183a67bdc2ebc98691c9dede866e4a.png";